/**********Sticky header ************ */
document.addEventListener("DOMContentLoaded", onDOMReady);
function onDOMReady() {
    let menuHeader = document.querySelector('header');
    let body = document.querySelector('body');
    if(menuHeader && body) {
        const scrollHeight = Math.max(
            document.body.scrollHeight, document.documentElement.scrollHeight,
            document.body.offsetHeight, document.documentElement.offsetHeight,
            document.body.clientHeight, document.documentElement.clientHeight
        );
        window.addEventListener('scroll', onWindowScroll);
        function onWindowScroll() {
            if(window.document.scrollingElement.scrollTop > 120 && scrollHeight > window.innerHeight + 200){
                menuHeader.classList.add("sticky");
                body.classList.add("sticky-margin-top");
            } else {
                body.classList.remove("sticky-margin-top");
                menuHeader.classList.remove("sticky")
            }
        }
    }
}
/* **** Main menu **** */
function mainMenuHandler() {
    const mainMenu = document.querySelector('.main-menu');
    if (!mainMenu) return;
    const menuItems = mainMenu.querySelectorAll('.main-menu__list__item');
    for(let i = 0; i < menuItems.length; i++) {
        if (menuItems[i].classList.contains('current')) break;
        menuItems[i].classList.add('selected');
    }
}
mainMenuHandler();

/* **** Auto resize textarea field **** */
export class ResizeTextArea {
    constructor() {
        this.textarea = document.querySelector('textarea');
        this.rows = this.textarea.getAttribute('rows');
        this.textarea.addEventListener('input', this.autosize.bind(this));
    }

    autosize() {
        const previousRows = this.rows;
        const lines = this.textarea.value.split('\n').length;
        const characters = this.textarea.value.length;
        const rows = Math.max(lines, Math.ceil(characters / this.textarea.cols));
        if (rows !== previousRows) {
            this.textarea.setAttribute('rows', rows);
            this.rows = rows;
            this.textarea.dispatchEvent(new Event('change'));
        }
    }
}

/* **** Rules adding margin after blocks **** */
function marginRules() {
    const sections = document.querySelectorAll('section.product-description-section');
    const productCatalog = document.querySelectorAll('div.product-catalog');
    if(sections && sections.length > 0) {
        sections.forEach(section => {
            if (section.nextElementSibling && section.nextElementSibling.tagName.toLowerCase() === 'div') {
                section.classList.add('has-div');
            }
        });
    }
    if(productCatalog && productCatalog.length > 0) {
        productCatalog.forEach(div => {
            if (div.nextElementSibling && div.nextElementSibling.tagName.toLowerCase() !== 'section') {
                div.classList.add('not-has-section');
            }
        });
    }
}
marginRules();

/* **** Mobile menu (burger + accordion) **** */
const MOBILE_MENU_BP = 991.98;

const isMobileMenuViewport = () => window.innerWidth <= MOBILE_MENU_BP;

const measureSubmenuHeight = (submenu) => {
    submenu.style.maxHeight = 'none';
    const height = submenu.scrollHeight;
    submenu.style.maxHeight = '';
    return height;
};

const refreshOpenSubmenuHeights = (root) => {
    root.querySelectorAll('li.menu-item-has-children.open').forEach((li) => {
        const submenu = li.querySelector(':scope > .sub-menu');
        if (submenu instanceof HTMLElement) {
            submenu.style.maxHeight = `${measureSubmenuHeight(submenu)}px`;
        }
    });
};

const setSubmenuOpen = (li, open) => {
    const submenu = li.querySelector(':scope > .sub-menu');
    const toggle = li.querySelector(':scope > .wrapper > .submenu-toggle');
    if (!(submenu instanceof HTMLElement)) return;

    li.classList.toggle('open', open);

    if (toggle) {
        toggle.classList.toggle('active', open);
        toggle.setAttribute('aria-expanded', String(open));
    }

    if (open) {
        requestAnimationFrame(() => {
            submenu.style.maxHeight = `${measureSubmenuHeight(submenu)}px`;
            refreshOpenSubmenuHeights(li.closest('.main-menu') || document);
        });
    } else {
        submenu.style.maxHeight = '0';
    }
};

const closeSiblingSubmenus = (currentLi) => {
    const parentList = currentLi.parentElement;
    if (!parentList) return;

    parentList.querySelectorAll(':scope > li.menu-item-has-children.open').forEach((li) => {
        if (li !== currentLi) setSubmenuOpen(li, false);
    });
};

const resetAllSubmenus = (root) => {
    root.querySelectorAll('li.menu-item-has-children.open').forEach((li) => {
        li.classList.remove('open');
        const toggle = li.querySelector(':scope > .wrapper > .submenu-toggle');
        if (toggle) {
            toggle.classList.remove('active');
            toggle.setAttribute('aria-expanded', 'false');
        }
    });
    root.querySelectorAll('.sub-menu').forEach((submenu) => {
        if (submenu instanceof HTMLElement) {
            submenu.style.maxHeight = '';
        }
    });
};

const clearDesktopMenuState = (menu) => {
    resetAllSubmenus(menu);
    menu.classList.remove('show');
    menu.inert = false;
};

const initMainMenu = () => {
    const menu = document.querySelector('.main-menu');
    const burgerBtn = document.querySelector('.burger-menu');
    if (!menu || !burgerBtn) return;

    let menuOpen = false;
    let scrollPosition = 0;

    const syncDrawerInert = () => {
        if (!('inert' in menu)) return;
        menu.inert = isMobileMenuViewport() && !menuOpen;
    };

    const setAria = (isOpen) => {
        burgerBtn.setAttribute('aria-expanded', String(isOpen));
        burgerBtn.setAttribute(
            'aria-label',
            isOpen ? 'Menü schließen' : 'Menü öffnen',
        );
    };

    const closeMenu = ({ restoreScroll = true } = {}) => {
        if (!menuOpen) return;

        menuOpen = false;
        burgerBtn.classList.remove('show');
        menu.classList.remove('show');
        document.body.classList.remove('show');
        document.documentElement.classList.remove('show');
        setAria(false);
        resetAllSubmenus(menu);
        syncDrawerInert();

        if (restoreScroll) {
            window.scrollTo({ top: scrollPosition, behavior: 'auto' });
        }
    };

    const openMenu = () => {
        menuOpen = true;
        burgerBtn.classList.add('show');
        menu.classList.add('show');
        document.body.classList.add('show');
        document.documentElement.classList.add('show');
        setAria(true);
        scrollPosition = window.scrollY;
        syncDrawerInert();
    };

    if (isMobileMenuViewport()) {
        syncDrawerInert();
    } else {
        clearDesktopMenuState(menu);
    }

    burgerBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (menuOpen) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    menu.addEventListener('click', (e) => {
        if (!menuOpen) return;

        const toggle = e.target.closest('.submenu-toggle');
        if (toggle && isMobileMenuViewport()) {
            e.preventDefault();
            e.stopPropagation();

            const li = toggle.closest('li.menu-item-has-children');
            if (!li) return;

            const willOpen = !li.classList.contains('open');
            closeSiblingSubmenus(li);
            setSubmenuOpen(li, willOpen);
            return;
        }

        const link = e.target.closest('a.step-btn');
        if (!link) return;

        const href = link.getAttribute('href');
        if (!href || href === '#') return;

        let url;
        try {
            url = new URL(href, location.href);
        } catch {
            return;
        }

        if (
            url.hash
            && url.origin === location.origin
            && url.pathname === location.pathname
        ) {
            closeMenu({ restoreScroll: false });
            return;
        }

        closeMenu();
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && menuOpen) {
            closeMenu();
        }
    });

    window.addEventListener('resize', () => {
        if (isMobileMenuViewport()) {
            syncDrawerInert();
            return;
        }

        if (menuOpen) {
            closeMenu({ restoreScroll: false });
        }
        clearDesktopMenuState(menu);
        burgerBtn.classList.remove('show');
        document.body.classList.remove('show');
        document.documentElement.classList.remove('show');
        menuOpen = false;
        setAria(false);
    });
};

initMainMenu();

/* **** Search Toggle **** */
const searchHandler = () => {
    const searchToggle = document.querySelector('.search-toggle');
    const searchForm = document.querySelector('.header-search-form');
    const searchInput = document.querySelector('.search-form__field');

    if (!searchToggle || !searchForm) return;

    searchToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        searchForm.classList.add('active');
        document.body.classList.add('search-active');
        setTimeout(() => {
            if (searchInput) searchInput.focus();
        }, 300);
    });

    // Close on click outside
    document.addEventListener('click', (e) => {
        if (searchForm.classList.contains('active') && !searchForm.contains(e.target)) {
            searchForm.classList.remove('active');
            document.body.classList.remove('search-active');
        }
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && searchForm.classList.contains('active')) {
            searchForm.classList.remove('active');
            document.body.classList.remove('search-active');
        }
    });
};

searchHandler();

/* **** FAQ Accordion **** */
const faqAccordionHandler = () => {
    const faqItems = document.querySelectorAll('.faq__item');
    if (!faqItems.length) return;

    faqItems.forEach(item => {
        const question = item.querySelector('.faq__item-question');
        const answer = item.querySelector('.faq__item-answer');

        question.addEventListener('click', () => {
            const isActive = item.classList.contains('active');

            // Close all items
            faqItems.forEach(otherItem => {
                otherItem.classList.remove('active');
                otherItem.querySelector('.faq__item-answer').style.display = 'none';
            });

            // If the clicked item was not active, open it
            if (!isActive) {
                item.classList.add('active');
                answer.style.display = 'block';
            }
        });
    });
};

faqAccordionHandler();

/* **** Sticky Nav & Anchors **** */
const stickyNavHandler = () => {
    const navLinks = document.querySelectorAll('.sticky-nav__link');
    const sections = document.querySelectorAll('.detail-section');
    
    if (!navLinks.length) return;

    // Smooth scroll for anchor links
    navLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            const href = link.getAttribute('href');
            if (href && href.startsWith('#')) {
                const targetId = href.substring(1);
                const targetElement = document.getElementById(targetId);
                
                if (targetElement) {
                    e.preventDefault();
                    const headerOffset = 150;
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });
                }
            }
        });
    });

    if (!sections.length) return;

    // Intersection Observer to highlight active link
    const observerOptions = {
        root: null,
        rootMargin: '-150px 0px -70% 0px',
        threshold: 0
    };

    const observerCallback = (entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const id = entry.target.getAttribute('id');
                navLinks.forEach(link => {
                    link.classList.remove('is-active');
                    if (link.getAttribute('href') === `#${id}`) {
                        link.classList.add('is-active');
                    }
                });
            }
        });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    sections.forEach(section => observer.observe(section));
};

stickyNavHandler();


document.addEventListener('DOMContentLoaded', function() {
    const forms = document.querySelectorAll('.wpcf7-form');

    forms.forEach(form => {
        const submitBtn = form.querySelector('.wpcf7-submit');
        if (!submitBtn) return;

        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.5';
        submitBtn.style.cursor = 'not-allowed';

        const requiredFields = form.querySelectorAll('[aria-required="true"], .wpcf7-validates-as-required');

        function checkRequiredFields() {
            let allFilled = true;

            requiredFields.forEach(field => {
                if (field.type === 'hidden') return;
                if (field.type === 'checkbox' || field.type === 'radio') {
                    const name = field.name;
                    const checkedFields = form.querySelectorAll(`[name="${name}"]:checked`);
                    if (checkedFields.length === 0) allFilled = false;
                }
                else if (field.tagName === 'SELECT') {
                    if (!field.value || field.value === '') allFilled = false;
                }
                else {
                    if (!field.value.trim()) allFilled = false;
                }
            });
            submitBtn.disabled = !allFilled;
            submitBtn.style.opacity = allFilled ? '1' : '0.5';
            submitBtn.style.cursor = allFilled ? 'pointer' : 'not-allowed';
        }

        requiredFields.forEach(field => {
            field.addEventListener('input', checkRequiredFields);
            field.addEventListener('change', checkRequiredFields);
            field.addEventListener('blur', checkRequiredFields);
        });
        checkRequiredFields();
    });
});
